module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', {
    staticClass: "group group--contentful group--sidebar"
  }, [_c('h1', {
    staticClass: "h1",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "p fw-medium"
  }, [_vm._v(_vm._s(_vm.excerpt))]), _vm._v(" "), _c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2 mb c-mid fw-bold",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Learn more")]), _vm._v(" "), _c('ul', {
    staticClass: "list list--articles mt"
  }, _vm._l((_vm.orderArticles), function(article, index) {
    return _c('li', {
      key: article.id,
      staticClass: "list__item m0"
    }, [_c('a', {
      staticClass: "link p tdn m0 df df--column",
      on: {
        "click": function($event) {
          return _vm.navigateToArticle(article)
        }
      }
    }, [_c('h4', {
      staticClass: "h4 c-accent fw-bold m0",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v(_vm._s(article.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(article.sub))])]), _vm._v(" "), (index < _vm.articles.length - 1) ? _c('hr', {
      staticClass: "hr"
    }) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.richText) ? _c('hr', {
    staticClass: "hr"
  }) : _vm._e(), _vm._v(" "), (_vm.richText) ? _c('module-rich-text', {
    attrs: {
      "entry": _vm.richText
    }
  }) : _vm._e(), _vm._v(" "), (_vm.topic.author || _vm.topic.source || _vm.topic.copyright) ? _c('hr', {
    staticClass: "hr"
  }) : _vm._e(), _vm._v(" "), (_vm.topic.author) ? _c('p', {
    staticClass: "article__author fw-bold c-accent p",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.topic.author))]) : _vm._e(), _vm._v(" "), (_vm.topic.source) ? _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.topic.source))]) : _vm._e(), _vm._v(" "), (_vm.topic.copyright) ? _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.topic.copyright.text))]) : _vm._e(), _vm._v(" "), _c('module-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDisclaimer),
      expression: "showDisclaimer"
    }],
    attrs: {
      "modal": _vm.modalExternalData
    },
    on: {
      "close": function($event) {
        _vm.showDisclaimer = false
      }
    }
  }, [_c('template', {
    slot: "modal-footer"
  }, [_c('module-button', {
    nativeOn: {
      "click": function($event) {
        _vm.showDisclaimer = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('module-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.goToUrl.apply(null, arguments)
      }
    }
  }, [_vm._v("Yes")])], 1)], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24100f37"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/contentful/Topic.vue
// module id = 575
// module chunks = 0